import { Component } from "react";
import * as Sentry from "@sentry/browser";
import t from "prop-types";
import { getSupportEmail } from "@amplio-common/funcs/commonFunctionalities";
import CommonButton from "@app/common/components/material_ui/Button";
import { withRouter } from "react-router-dom";
import ErrorIcon from "@amplio-common/assets/img/computer_2022.png";
import { css } from "@emotion/react";
import { trackEvent } from "@amplio-common/analytics";
import { Trans } from "@lingui/macro";

const rootStyle = ({ typography, colors }) => css`
  height: 100%;
  color: ${colors.text.main};
  font-family: ${typography.fontFamily};
  /* color: #A1A1A1; */
  /* font-weight: bold; */
  > div {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    
    > div:first-of-type {
      padding-top: 60px;
    }
    > div {
      font-size: 16px;
      /* color: #29436D; */
      text-align: center;
      max-width: 90%;
    }
  }

  img {
    width: 380px;
  }
  a {
    color:  ${colors.primary.main};
  }
`;

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { errorInfo: null };
  }

  componentDidCatch(error, errorInfo) {
    // Catch errors in any components below and re-render with error message
    // if (error?.message?.includes("chunk")) {
    //   return this.handleReloadPage();
    // }
    this.setState({ errorInfo });

    Sentry.withScope(scope => {
      Object.keys(errorInfo).forEach(key => {
        scope.setExtra(key, errorInfo[key]);
      });
      Sentry.captureException(error);
    });

    try {
      trackEvent("global_app_error", { error, errorInfo });
    } catch (e) {
      console.error("failed to send global error to MP");
    }
  }



  handleReloadPage = () => {
    const { history } = this.props;
    // this.setState({ error: null, errorInfo: null }, history.push("/home/"));
    try {
      history.push("/home/");
    } catch (e) {
      console.error(e);
    }

    window.location.reload();
  }

  render() {
    const supportEmail = getSupportEmail();

    if (this.state.errorInfo) {
      // Error path
      return (
        <div css={rootStyle}>
          <div>
            <img alt="error" className="errorImage" src={ErrorIcon} />
            <div><Trans>Oops - something went wrong.</Trans></div>
            <div><Trans>Please try to reload the page.</Trans></div>
            <br />
            <div><Trans>If the problem persists please contact our tech support at:</Trans></div>
            <div><a href={`mailto:${supportEmail}`} target="_blank" rel="noopener noreferrer">{supportEmail}</a></div>
            <br />
            <CommonButton color="primary" onClick={this.handleReloadPage} style={{ marginTop: "20px" }}>
              <Trans>Reload page</Trans>
            </CommonButton>
          </div>
        </div>
      );
    }
    // Normally, just render children
    return this.props.children;
  }
}


ErrorBoundary.propTypes = {
  children: t.oneOfType([t.array, t.object]),
  history: t.object,
};

export default withRouter(ErrorBoundary);
